import {
  Module,
  VuexModule,
  getModule,
  Mutation,
} from "vuex-module-decorators";

const name = "localSettings";

import store from "@/store";
import { ComBoxHumidityUnit } from "../../data/models/ComBoxHumidityUnit";
import { ClientInfo } from "@/data/models/ClientInfo";
import { HyDryMessagesSettings } from "@/data/models/HyDryMessagesConfig";

if (store.state[name]) {
  store.unregisterModule(name);
}

@Module({ dynamic: true, namespaced: true, store, name: name })
export class LocalSettingsVuexModule extends VuexModule {
  /**
   * @deprecated comBoxHumidityUnit is deprecated and should not be used.
   */
  comBoxHumidityUnit = ComBoxHumidityUnit.RELATIVE_HUMIDITY;
  didSetComBoxHumidityUnitFromClientClientInfo = false;
  /**
   * @deprecated minProgramChainDurationInMin is deprecated and should not be used.
   */
  minProgramChainDurationInMin = 0;

  /**
   * @deprecated hyDryMessageSettings is deprecated and should not be used.
   */
  hyDryMessageSettings: HyDryMessagesSettings = {
    messagesEnabled: true,
    mailboxEnabled: true,
    messageFilters: {
      filterAll: {},
      filterNoProject: {},
      filterMyProject: [],
      showMessagesToProjectOwners: true,
      showMessagesToProjectSupervisors: true,
      erp: [],
    },
  };

  /**
   * @deprecated setHyDryMessageSettings is deprecated and should not be used.
   */
  @Mutation
  setHyDryMessageSettings(hyDryMessageSettings: HyDryMessagesSettings) {
    this.hyDryMessageSettings = hyDryMessageSettings;
  }

  keepAlive: string[] = [];

  @Mutation
  setKeepAlive(keepAlive: string[]) {
    this.keepAlive = keepAlive;
  }
  
  /**
   * @deprecated setMinProgramChainDurationInMinutes is deprecated and should not be used.
   */
  @Mutation
  setMinProgramChainDurationInMinutes(minProgramChainDurationInMin: number) {
    this.minProgramChainDurationInMin = minProgramChainDurationInMin;
  }

  /**
   * @deprecated setComBoxHumidityUnit is deprecated and should not be used.
   */
  @Mutation
  setComBoxHumidityUnit(comBoxHumidityUnit: ComBoxHumidityUnit) {
    this.comBoxHumidityUnit = comBoxHumidityUnit;
  }

  /**
   * @deprecated setComBoxHumidityUnitFromClientInfo is deprecated and should not be used.
   */
  @Mutation
  setComBoxHumidityUnitFromClientInfo(clientInfo: ClientInfo) {
    const newComBoxHumidityUnit = clientInfo.comBoxHumidityUnit;
    if (
      !this.didSetComBoxHumidityUnitFromClientClientInfo &&
      newComBoxHumidityUnit
    ) {
      this.comBoxHumidityUnit = newComBoxHumidityUnit;
      this.didSetComBoxHumidityUnitFromClientClientInfo = true;
    }
  }
}

export const LocalSettingsModule = getModule(LocalSettingsVuexModule);
